import type { TFunction } from 'i18next';

/**
 * A filing frequency as the CRM or the engine stores it ("Monthly", "SemiAnnual", "Semi-Annually") in the reader's
 * language (polish pass, 2026-10-28: Spanish staff saw "Monthly"). The stored value stays the key everywhere it is
 * compared or saved; this is for display only. A value this build doesn't know shows as stored, never blank.
 */
export function cadenceName(t: TFunction, frequency: string): string {
  return t(`clientDetailPage.history.cadenceName.${frequency}`, { defaultValue: frequency });
}
